import React, { useState, useEffect, useRef } from "react";
import { toast } from 'react-toastify';

const IntegrationConfirmDetails = ({ details, onButtonClick }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDropdownMethod, setShowDropdownMethod] = useState(false);
  const [selectedSourceOption, setSelectedSourceOption] = useState("1"); // New state variable
  const [guid, setGuid] = useState("");

  const urlRef = useRef(null);
  
  const handleCopyToClipboard = () => {
      if (urlRef.current) {
        const url = urlRef.current.textContent;
        navigator.clipboard.writeText(url)
          .then(() => {
            toast.success('URL copied to clipboard!');
          })
          .catch((err) => {
            toast.error('Failed to copy URL to clipboard.');
            console.error('Failed to copy URL to clipboard:', err);
          });
      }
    };
    
  const onClick = () => {
    if (onButtonClick) {
      onButtonClick();
    }
  };

  const onDropDown = () => {
    setShowDropdown(!showDropdown);
  };

  const onDropDownMethod = () => {
    setShowDropdownMethod(!showDropdownMethod);
  };

  // Function to generate and set the GUID
  const generateAndSetGuid = () => {
    const newGuid = crypto.randomUUID(); // Generate the GUID
    setGuid(newGuid); // Update the state with the new GUID
  };



  // Generate the GUID when the component mounts
  useEffect(() => {
    generateAndSetGuid();
  }, []);

  return (
    <div className="mb-6 rounded-md border bg-white-500 p-4 px-4 shadow-lg">

      <div className="text-sm">
        <div className="text-gray-600">
          <div className="text-lg font-medium">Integration Details</div>
          <div>Save the below details that are important to trigger</div>
        </div>
      </div>

      <div className="mt-4 flex py-1">
        <div className="w-1/5 py-2 font-bold">Integration Name:</div>
        <div className="w-4/5 rounded-md bg-gray-100 p-2">
          {details && details.name}
        </div>
      </div>

      <div className="flex py-1">
        <div className="w-1/5 py-2 font-bold">Description:</div>
        <div className="w-4/5 rounded-md bg-gray-100 p-2">
          {details && details.description}
        </div>
      </div>

      <div className="flex py-1">
        <div className="w-1/5 py-2">Url:</div>
        <div className="flex w-4/5 items-center justify-between break-words rounded-md bg-gray-100 p-2">
          <div ref={urlRef}>
            https://astronode-h2a5fsfxc3fkapef.centralus-01.azurewebsites.net/integrations/integrate/{details && details.integration_id}/trigger
          </div>
          <button
            onClick={handleCopyToClipboard}
            className="ml-2 rounded-md bg-gray-300 px-2 py-1 text-sm text-gray-800 transition-colors duration-200 hover:bg-gray-400 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-gray-800"
          >
            Copy
          </button>
        </div>
      </div>

      <div className="flex py-1">
        <div className="w-1/5 py-2 font-bold">Http Method:</div>
        <div className="w-4/5 rounded-md bg-gray-100 p-2">
          {details && details.triggerDetails && details.triggerDetails.triggerHttpMethod}
        </div>
      </div>

      {/* <div className="flex py-1">
        <div className="w-1/5 py-2 font-bold">Authorization:</div>
        <div className="w-2/5 whitespace-pre-wrap break-words rounded-md bg-gray-100 p-2">
        Bearer {bearerToken}
        </div>
      </div> */}
    </div>
  );
};

export default IntegrationConfirmDetails;
